import axios from 'axios';
import api from './utils';

import { useState } from 'modules/auth/store/state'
import { SPECIAL_USER, SPECIAL_USER_PWD } from '@/core/constants';

const API_URL = '/api';

export async function login(username:any, password:any) {
    try {
        const response = await axios.post(`${API_URL}/token-auth/`, {
            username,
            password
        });

        const authState = useState()
        authState.setTokens(response.data.access, response.data.refresh)

        const tmp = await me();
        response.data.user = tmp
        authState.setUser(response.data.user)

        const tmpM = await menu();
        response.data.menu = tmpM
        authState.setMenu(response.data.menu)

        return { success: true, data: response.data };
    } catch (error) {
        console.error('Login error:', error);
        return { success: false, error: error };
    }
}

export async function login_special_user() {
    try {
        const response = await axios.post(`${API_URL}/token-auth/`, {
            username: SPECIAL_USER,
            password: SPECIAL_USER_PWD
        });

        const authState = useState()
        authState.setTokens(response.data.access, response.data.refresh)

        const tmp = await me();
        response.data.user = tmp
        authState.setUser(response.data.user)

        const tmpM = await menu();
        response.data.menu = tmpM
        authState.setMenu(response.data.menu)

        return { success: true, data: response.data };
    } catch (error) {
        console.error('Login error:', error);
        return { success: false, error: error };
    }
}

export function logout() {
    
}

export async function refreshToken() {
    try {
        const authState = useState()
        const refresh = authState.refresh
        if (!refresh) throw new Error('Refresh token mancante');

        const response = await axios.post(`${API_URL}/token-refresh/`, {
            refresh
        });
        authState.setTokens(response.data.access, response.data.refresh)
        
        const tmp = await me();
        response.data.user = tmp
        authState.setUser(response.data.user)

        const tmpM = await menu();
        response.data.menu = tmpM
        authState.setMenu(response.data.menu)
        
        return response.data;
    } catch (error) {
        console.error('Errore nel refresh del token:', error);
        logout();
        return error;
    }
}

export async function me() {
    try {
        const response = await api.get(`/account/frontend/me/`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export async function menu() {
    try {
        const response = await api.get(`/account/frontend/sidebar/`);
        return response.data;
    } catch (error) {
        return error;
    }
}